import { Footerdemo } from "@/components/ui/footer-section";

const Footer = () => {
    return (
        <div className="block">
            <Footerdemo />
        </div>
    );
}

export default Footer;
